import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { toastEvents } from '@navstation-portal/shared/data-access/toaster';
import { Events } from '@ngrx/signals/events';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class Toaster {
  private events = inject(Events);
  messageService = inject(MessageService);

  constructor() {
    this.events
      .on(toastEvents.toastSuccess)
      .pipe(takeUntilDestroyed())
      .subscribe(({ payload: toast }) => {
        const successToast = {
          severity: 'success',
          summary: toast.summary,
          detail: toast.detail,
        };
        this.messageService.add(successToast);
      });
    this.events
      .on(toastEvents.toastError)
      .pipe(takeUntilDestroyed())
      .subscribe(({ payload: toast }) => {
        const errorToast = {
          severity: 'error',
          summary: toast.summary,
          detail: toast.detail,
        };
        this.messageService.add(errorToast);
      });
  }
}
